export const STATUS_PENDING = 'pending'
export const STATUS_COMPLETED = 'completed'
export const STATUS_FINISHED = 'finished'
